module.exports = __webpack_public_path__ + "static/media/badge-icon.92af370d.png";